// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"GI-z","smallCardRow":"HI-z","largeCardRow":"II-z","productSearchRow":"JI-z","curatedRow":"KI-z"};